import React from "react";
import "./styles.css";
import {useTranslation} from "react-i18next";

const CustomButton = ({keyTranslate}) => {
    const [t] = useTranslation("common");

    return (
        <button className={"customButton"}>{t(keyTranslate)}</button>
    );
}

export default CustomButton;
